export default __webpack_public_path__ + "static/media/pool-bg.11674d29.webp";